import React, { memo } from 'react';
import { Testimonial } from './Testimonial';
export function MirrorReality() {
  return <section className="py-12 md:py-24 px-4 bg-white relative" data-id="element-84">
      <div className="max-w-3xl mx-auto text-center mb-10 md:mb-16" data-id="element-85">
        <h2 className="text-3xl md:text-4xl font-bold mb-8" data-id="element-86">
          Do you remember that woman?
        </h2>

        <div className="space-y-6 text-lg md:text-xl text-brand-charcoal/80 leading-relaxed" data-id="element-87">
          <p data-id="element-88">
            The one who felt electric, confident, and completely in control of
            her reflection?
          </p>
          <p data-id="element-89">
            Then, motherhood happened. And while you wouldn't trade your baby
            for anything in the world... you look in the mirror and see a
            stranger.
          </p>
          <p data-id="element-90">
            The "soft" tummy that won't budge. The "brain fog" that makes you
            forget your keys. The soul-crushing exhaustion that makes "feeling
            sexy" feel like a distant memory from a past life.
          </p>
          <p className="font-bold text-brand-coral text-2xl mt-8 font-heading" data-id="element-91">
            I'm here to tell you: That woman isn't gone. She's just waiting for
            you to find her.
          </p>
        </div>
      </div>

      <Testimonial imageSrc="https://cdn.magicpatterns.com/uploads/9dmFB42Ahau61n8AjSkmy2/testimony_1_before__after.png" quote="I thought at this price it was going to be another generic PDF. I was wrong. It's the most comprehensive thing I've read since giving birth. No, I didn't get 'abs' in a month, but my bloating is gone, my pelvic floor feels solid, and I finally have the energy to deal with 3 AM wake-up calls. It costs less than my morning coffee and actually changed my life." author="Sarah J., Chicago, IL" result="Functional core & identity reclaimed." imagePosition="left" data-id="element-92" />

      <div className="flex justify-center mt-6 md:mt-12" data-id="element-93">
        <div className="w-24 h-1 bg-brand-sage/30 rounded-full" data-id="element-94"></div>
      </div>
    </section>;
}